<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc"></a>
<a id="page_vii"></a>
<h2 class="fronttitle" id="toc_p1">CONTENTS</h2>
<p class="toc" id="toc_p2">
<a href="#/preface">Preface</a>
</p>
<p class="toc1" id="toc_p3">
<b>
<a href="#/intro">
<span class="small">INTRODUCTION</span>
</a>
</b>
</p>
<p class="toc1" id="toc_p4">
<a href="#/chap01"><span class="small"><b>ONE</b> BONES OF CONTENTION</span><br/>The American Incognitum and the Discovery of Extinction</a>
</p>
<p class="toc1" id="toc_p5">
<a href="#/chap02"><span class="small"><b>TWO</b> PARADISE LOST</span><br/>Unraveling the Mysteries of Insular Species</a>
</p>
<p class="toc1" id="toc_p6">
<span href="#/chap03" title="Link target outside of Sample">
<span class="small"><b>THREE</b> SOUNDING THE ALARM ABOUT<br/>CONTINENT-WIDE WILDLIFE EXTINCTION</span>
</span>
</p>
<p class="toc1" id="toc_p7">
<span href="#/chap04" title="Link target outside of Sample">
<span class="small"><b>FOUR</b> NATIONALISM, NOSTALGIA,<br/>AND THE CAMPAIGN TO SAVE THE BISON</span>
</span>
</p>
<p class="toc1" id="toc_p8">
<span href="#/chap05" title="Link target outside of Sample"><span class="small"><b>FIVE</b> GOING GLOBAL</span><br/>The American Committee and the First Inventory of Extinction</span>
</p>
<p class="toc1" id="toc_p9">
<span href="#/chap06" title="Link target outside of Sample"><span class="small"><b>SIX</b> THE LATIN AMERICAN TURN</span><br/>Nature Protection in the Western Hemisphere</span>
</p>
<a id="page_viii"></a>
<p class="toc1" id="toc_p10">
<span href="#/chap07" title="Link target outside of Sample"><span class="small"><b>SEVEN</b> ENTER ECOLOGY</span><br/>Preserving Nature’s Living Laboratory</span>
</p>
<p class="toc1" id="toc_p11">
<span href="#/chap08" title="Link target outside of Sample">
<span class="small"><b>EIGHT</b> RECONSIDERING RAPTORS<br/>DURING THE INTERWAR YEARS</span>
</span>
</p>
<p class="toc1" id="toc_p12">
<span href="#/chap09" title="Link target outside of Sample"><span class="small"><b>NINE</b> SALVATION THROUGH SCIENCE?</span><br/>The First Life-History Studies of Endangered Species</span>
</p>
<p class="toc1" id="toc_p13">
<span href="#/chap10" title="Link target outside of Sample"><span class="small"><b>TEN</b> “THE NATION’S FIRST RESPONSIBILITY”</span><br/>Saving Endangered Species in the Age of Ecology</span>
</p>
<p class="toc1" id="toc_p14">
<span href="#/conc" title="Link target outside of Sample">
<span class="small">
<b>CONCLUSION</b>
</span>
</span>
</p>
<p class="toc1" id="toc_p15">
<span href="#/notes" title="Link target outside of Sample">Notes</span>
</p>
<p class="toc1" id="toc_p16">
<span href="#/biblio" title="Link target outside of Sample">Select Bibliography</span>
</p>
<p class="toc1" id="toc_p17">
<span href="#/index" title="Link target outside of Sample">Index</span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?49615810